import { gql } from "@apollo/client";

const UPDATE_MULTIPLE_RANKINGS_POINTS = gql`
  mutation updateMultipleRankingCategoryPoints(
    $ids: [Int!]!
    $updateRankingCategoryPointsInput: UpdateRankingCategoryPointInput!
  ) {
    updateMultipleRankingCategoryPoints(
      ids: $ids
      updateRankingCategoryPointsInput: $updateRankingCategoryPointsInput
    ) {
      id
    }
  }
`;

export default UPDATE_MULTIPLE_RANKINGS_POINTS;
